import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { ObjectType } from '../../types/objectType';
import { changeParams } from '../../redux/modules/reducer';

export const CustomSelect = ({ defaultValue,
    options, id }: ObjectType) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(defaultValue);
    const label = id.toUpperCase();

    const handleChange = (event: SelectChangeEvent) => {
        setValue(event.target.value as string);
        const params = {
            [id]: event.target.value
        };
        if (id === 'step') {
            if (parseInt(event.target.value) === 5) {
                params['category'] = 'none';
                params['enabledCategory'] = false;
            } else if (parseInt(event.target.value) === 0) {
                params['category'] = 'electricity';
                // params['enabledCategory'] = false;
            } else {
                params['enabledCategory'] = true;
            }
        }
        dispatch(changeParams(params));
    };

    return (
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="demo-simple-select-label">{label}</InputLabel>
            <Select

                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                label={label}
                onChange={handleChange}
            >
                {options.map((o) => <MenuItem key={`item-${label}-${o}`} value={o}>{o}</MenuItem>)}
            </Select>
        </FormControl>
    );
};